var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',[_c('div',{staticClass:"row my-5 g-2"},_vm._l((_vm.apps),function(anApp,i){return _c('block',{key:`tool-${i}`,attrs:{"resource":anApp},on:{"resource-clicked":_vm.handleResourceClick}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }